module.exports = ".product-sel {\n    border: 0px;\n    width: 100%;\n    height: 10px;\n}\n.product-spacer {\n    border: 0px;\n    width: 20;\n    height: 10px;\n}\n.clearfix {\n    clear: both;\n}\n.mat-radio-button.checked{\n    border-color: rgb(66, 134, 244);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/product-selection/product-selection.component.css
// module id = ./src/app/shared/components/product-selection/product-selection.component.css
// module chunks = main